import React from 'react';

const ExportIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="action/export">
      <g id="vector">
        <path d="M15.9615 0.30908C15.9109 0.18664 15.8134 0.08911 15.6909 0.03845C15.6298 0.01318 15.5651 0 15.5 0H8.5C8.22363 0 8 0.22363 8 0.5C8 0.77637 8.22363 1 8.5 1H14.293L7.14648 8.14648C6.95117 8.34179 6.95117 8.6582 7.14648 8.85351C7.24414 8.95117 7.37208 8.99999 7.50001 8.99999C7.62794 8.99999 7.75586 8.95116 7.85352 8.85351L15 1.70703V7.5C15 7.77637 15.2236 8 15.5 8C15.7764 8 16 7.77637 16 7.5V0.5C16 0.43494 15.9868 0.37018 15.9615 0.30908Z" />
        <path d="M12.5 9C12.2236 9 12 9.22363 12 9.5V14C12 14.5518 11.5518 15 11 15H2C1.44824 15 1 14.5518 1 14V5C1 4.44824 1.44824 4 2 4H6.5C6.77637 4 7 3.77637 7 3.5C7 3.22363 6.77637 3 6.5 3H2C0.89746 3 0 3.89746 0 5V14C0 15.1025 0.89746 16 2 16H11C12.1025 16 13 15.1025 13 14V9.5C13 9.22363 12.7764 9 12.5 9Z" />
      </g>
    </g>
  </svg>
);

export default ExportIcon;
